import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Col, Modal, Nav, Row, Tab } from "react-bootstrap";

import { setComponentLoadingEffect } from "../../../Redux/common/Loader/action";
import { api_without_cancellation } from "../../../api/api";
import { addEvent, fetchCaseProvider, searchUserInEventTab } from "../../../Providers/main";
import { formatCalendarDate, getCaseId } from "../../../Utils/helper";
import ClientSelection from "../../Calendar/Components/ClientsSelection";
import OtherFirmUsers from "../../Calendar/Components/OtherFirmUsers";
import { safeToISOString } from "../../Calendar/Util/format";
import "./eventModal.css";
import bdayIcon from "../../../assets/images/birthdayicon.svg";
import avatar from "../../../assets/images/avatar.svg";
import incident from "../../../assets/images/incident.svg";

import useGetClientBySearch from "./hooks/useGetSearchClient";
import { EventClientTable } from "./components/client-table";

export const DetailHeading = ({ label, value, icon }) => (
  <div className="d-flex align-items-center height-21">
    <img
      className="img-19px mr-5px"
      style={{
        border: "none",
        overflow: "hidden",
        borderRadius: "50%",
      }}
      src={icon}
      alt={`${label} Icon`}
    />
    <h6
      className="mb-0 text-nowrap height-21 d-flex align-items-center"
      style={{ fontSize: "14px" }}
    >
      {value || "N/A"}
    </h6>
  </div>
);

const EventModal = ({
  show,
  setCurrentEvents,
  setShow,
  litigationEventType,
  litigationEvent,
  overallProviders,
  caseList,
  todoCategoryType,
  caseProviderList,
}) => {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState("litigationAct");
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [error, setError] = useState({ error: false, errorMsg: "No error " });
  const [firmUsers, setFirmUser] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [uniqueIdUsers, setUniqueIdUsers] = useState([]);
  const [caseProvider, setCaseProvider] = useState(caseProviderList);
  // const [treatmentDayInformation, setTreatmentDayInformation] = useState(treatmentDayInfo);
  const [assignedFirmUsers, setAssignedFirmUsers] = useState([]);
  const [uniqueIdFirmUsers, setUniqueIdFirmUsers] = useState([]);
  const [filterlitigationEvents, setFilterLitigationEvents] = useState(litigationEvent);

  // Define the icon mapping for static icons
  const iconMapping = {
    Birthday: bdayIcon,
    "Incident Date": incident,
    // "Case Type" will be handled dynamically
  };

  // const [search, setSearch] = useState("");
  const search = "";
  // const isLoading = useSelector(
  //   (state) => state?.loadEffect?.componentLoadStates?.calendarProviders
  // );
  const [caseSummary, setCaseSummary] = useState(useSelector((state) => state?.caseData?.summary));
  const [client, setClient] = useState(
    useSelector((state) => state?.caseData?.summary?.for_client)
  );
  const [caseId, setCaseId] = useState(getCaseId());
  const [searchResults, setSearchResults] = useState([]);
  const caseDataCurrentCase = useSelector((state) => state?.caseData?.current);
  const [currentCase, setCurrentCase] = useState([]);
  const [successBtnFlag, setSuccessBtnFlag] = useState(false);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [errorMsg, setErrorMsg] = useState("");

  const case_users = [currentCase?.firm_user1, currentCase?.firm_user2, currentCase?.firm_user3];
  const case_users1 = [currentCase?.firm_user4, currentCase?.firm_user5, currentCase?.firm_user6];
  const caseWorkers = currentCase?.workers ?? [];

  const [eventData, setEventData] = useState({
    case_id: caseId,
    for_provider: "",
    litigationActDescription: "",
    treatmentDayDescription: "",
    todoDescription: "",
    litigation_event_type: "",
    litigation_event: "",
    category_type: "",
    event_type: null,
    todoDate: null,
    treatmentDate: null,
    litigationDate: null,
  });

  const [blurModal, setBlurModal] = useState(false);

  useEffect(() => {
    setCaseProvider(caseProviderList);
  }, [caseProviderList]);
  // useEffect(() => {
  //   setTreatmentDayInformation(treatmentDayInfo);
  // }, [treatmentDayInfo]);

  useEffect(() => {
    setCurrentCase(caseDataCurrentCase);
    notesFirmUsersAPI(caseDataCurrentCase?.id);
  }, []);
  async function notesFirmUsersAPI(currentCaseId) {
    try {
      const response = await api_without_cancellation.get("api/notes_firm_users/", {
        params: { case_id: currentCaseId },
      });

      setFirmUser(response.data);
    } catch (e) {
      console.error(e);
    }
  }

  // const parseDate = (dateString) => {
  //   try {
  //     if (dateString === null || dateString === "") return;
  //     const [month, day, year] = dateString?.split("/");
  //     return new Date(year, month - 1, day);
  //   } catch (err) {
  //     return;
  //   }
  // };

  useEffect(() => {
    setSearchResults([]);
    if (search) {
      fetchSearchData();
    }
  }, [search]);

  const fetchSearchData = async () => {
    try {
      if (search.trim().length < 3) {
        return;
      }

      const response = await searchUserInEventTab(search);
      if (response.data.length === 0) {
        return;
      }

      setAssignedUsers([]);
      setUniqueIdUsers([]);
      setSearchResults(response.data);
    } catch (e) {
      setSearchResults([]);
      setCaseId(null);

      setErrorMsg(e.toString());
    }
  };

  useEffect(() => {
    setFilterLitigationEvents(
      litigationEvent?.filter(
        (i) => parseInt(i?.event_type_id?.id) === parseInt(eventData.litigation_event_type)
      )
    );

    setEventData((prevState) => ({
      ...prevState,
      litigation_event: "",
    }));
  }, [eventData.litigation_event_type, litigationEvent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEventData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDateChange = (name, date) => {
    setEventData((prevState) => ({
      ...prevState,
      [name]: date,
    }));
  };
  useEffect(() => {
    if (selectedTab === "litigationAct") {
      setSuccessBtnFlag(
        eventData.litigationActDescription.trim().length > 0 &&
          eventData.case_id !== "" &&
          eventData.litigation_event_type !== "" &&
          eventData.litigation_event !== "" &&
          eventData.litigationDate !== null
      );
    } else if (selectedTab === "todo") {
      setSuccessBtnFlag(
        eventData.todoDescription.trim().length > 0 &&
          eventData.case_id !== "" &&
          eventData.category_type !== "" &&
          eventData.todoDate !== null
      );
    } else if (selectedTab === "treatmentDay") {
      setSuccessBtnFlag(
        eventData.treatmentDayDescription.trim().length > 0 &&
          eventData.for_provider !== "" &&
          eventData.treatmentDate !== null
      );
    }
  }, [eventData, selectedTab]);

  const setToNoon = (date) => {
    const newDate = new Date(date);
    newDate.setHours(12, 0, 0, 0); // Set time to 12:00:00 PM
    return newDate;
  };

  const handleSubmit = async () => {
    try {
      if (!successBtnFlag) {
        setError({
          error: true,
          errorMsg: "Please fill out all required fields.",
        });
        return;
      }
      setError({ error: false, errorMsg: "No errors" });
      const dataWithFirmUser = [];
      let dataToAppend = {};
      let formattedEventData = {
        case_id: caseId,
        firm_users: [...new Set(uniqueIdUsers.concat(uniqueIdFirmUsers))].filter(
          (id) => id !== null
        ),
      };

      if (selectedTab === "litigationAct") {
        formattedEventData = {
          ...formattedEventData,
          name: eventData.litigationActDescription,
          event_id: eventData.litigation_event,
          event_type_id: eventData.litigation_event_type,
          event_type: "Litigation Events",
          date: setToNoon(eventData.litigationDate),
        };
        dataToAppend = {
          id: crypto.randomUUID(),
          title2:
            litigationEventType.find((i) => i.id === eventData.litigation_event_type)
              ?.litigation_event_type || "",
          title: `${litigationEventType.find((i) => i.id === eventData.litigation_event_type)?.litigation_event_type || ""} ${client?.first_name || ""} ${client?.last_name || ""}, ${caseSummary?.case_type?.name || ""}`,
          eventType: "litigationAct",
          caseType: caseSummary?.case_type?.name,
          clientFirstName: client?.first_name,
          clientLastName: client?.last_name,
          start: safeToISOString(setToNoon(eventData.litigationDate), true),
          allDay: true,
        };
      } else if (selectedTab === "todo") {
        formattedEventData = {
          ...formattedEventData,
          notes: eventData.todoDescription,
          todo_type: eventData.category_type,
          event_type: "ToDo Events",
          due_date: setToNoon(eventData.todoDate),
        };
        for (let i = 0; i < formattedEventData?.firm_users.length; i++) {
          dataToAppend = {
            id: crypto.randomUUID(),
            title2: eventData.todoDescription,
            title: `${
              todoCategoryType?.find((i) => {
                i.id === eventData.category_type;
              })?.tab_name ||
              eventData.todoDescription ||
              ""
            } ${client?.first_name || ""} ${client?.last_name || ""}, ${caseSummary?.case_type?.name || ""}`,
            eventType: "todo",
            clientFirstName: client?.first_name,
            clientLastName: client?.last_name,
            caseType: caseSummary?.case_type?.name,
            start: safeToISOString(setToNoon(eventData.todoDate)),
            allDay: true,
          };
          dataWithFirmUser.push(dataToAppend);
        }
      } else if (selectedTab === "treatmentDay") {
        formattedEventData = {
          for_provider: parseInt(eventData.for_provider),
          case_id: getCaseId(),
          description: eventData.treatmentDayDescription,
          event_type: "Treatment Dates",
          date: eventData.treatmentDate,
        };
        let clientDetails = {};

        overallProviders?.forEach((j) => {
          if (clientDetails?.id) return {};

          caseList?.forEach((k) => {
            if (eventData.for_provider === j?.id && j?.for_case === k?.id) {
              clientDetails = {
                for_provider: eventData?.for_provider,
                first_name: k?.for_client?.first_name,
                last_name: k?.for_client?.last_name,
                case_summary: k?.case_type?.name,
                id: eventData?.id,
              };
              return;
            }
          });
        });

        dataToAppend = {
          id: crypto.randomUUID(),
          title2: eventData.treatmentDayDescription,
          title: `${eventData.treatmentDayDescription || ""} ${caseProviderList?.find((i) => i.id === parseInt(eventData.for_provider))?.specialty?.name || ""} appt: ${clientDetails?.first_name || ""} ${clientDetails?.last_name || ""}, ${caseSummary?.case_type?.name || ""}`,
          eventType: "treatmentDates",
          caseType: clientDetails?.caseSummary,
          provider: caseProviderList?.find((i) => i.id === parseInt(eventData.for_provider)),
          clientFirstName: clientDetails?.first_name,
          clientLastName: clientDetails?.last_name,
          start: eventData.treatmentDate,
          allDay: true,
        };
      }
      await addEvent(formattedEventData);

      if (selectedTab === "todo") {
        setCurrentEvents((prevEvents) => [...prevEvents, ...dataWithFirmUser]);
      } else {
        setCurrentEvents((prevEvents) => [...prevEvents, dataToAppend]);
      }
      setShow(false);
      dispatch(setComponentLoadingEffect("detailBar", true));

      setTimeout(() => {
        dispatch(setComponentLoadingEffect("detailBar", false));
      }, 100);
    } catch (error) {
      console.error("Error submitting form:", error);

      dispatch(setComponentLoadingEffect("calendarProviders", false));
      setError({ error: true, errorMsg: error.toString() });
    }
  };

  // ✅ Correct
  useEffect(() => {
    const fetchData = async () => {
      await fetchCaseProvider(caseId);
    };

    fetchData();
  }, [caseId]);

  const [searchClientByName, setSearchClientByName] = useState({
    name: "",
  });
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const {
    data: apiSearchResult,
    fetchProviderBySearchTerm,
    error: apiError,
    loading: isLoadingApiSearch,
  } = useGetClientBySearch();

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchClientByName.name.length >= 3) {
        setDebouncedSearchTerm(searchClientByName.name);
      } else if (searchClientByName.name.length <= 2) {
        setDebouncedSearchTerm("");
        setSearchResults([]);
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [searchClientByName.name]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      fetchProviderBySearchTerm({ name: debouncedSearchTerm });
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (apiSearchResult?.data && apiSearchResult?.data?.length > 0) {
      setAssignedUsers([]);
      setUniqueIdUsers([]);
      setSearchResults(apiSearchResult.data);
    }
  }, [apiSearchResult]);

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="max-1050 modal-dialog-centered "
      contentClassName="custom-modal-new-provider"
      size="lg"
      style={{
        opacity: blurModal ? "0.5" : "1",
      }}
    >
      <div>
        <Modal.Header
          style={{
            borderBottom: "0px",
          }}
          className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
        >
          <Modal.Title
            className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
            id="modal_title"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            {selectedTab === "litigationAct"
              ? "ADD LITIGATION ACT"
              : selectedTab === "todo"
                ? "ADD TODO EVENT"
                : selectedTab === "search"
                  ? "SELECT CASE"
                  : "ADD TREATMENT DAY"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "0px" }}>
          <div
            className="custom-tab"
            style={{
              minHeight: "500px",
            }}
          >
            <Tab.Container defaultActiveKey={"litigationAct"}>
              <Nav
                variant="tabs"
                className="justify-content-around"
                style={{ marginTop: "5px", marginBottom: "5px" }}
              >
                <Nav.Link
                  className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite apply-before"
                  eventKey="search"
                  onClick={() => {
                    setSelectedTab("search");
                    setError({ error: false, errorMsg: "No error" });
                  }}
                >
                  Select Case
                </Nav.Link>
                <Nav.Link
                  className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite"
                  eventKey="litigationAct"
                  onClick={() => {
                    setSelectedTab("litigationAct");
                    setError({ error: false, errorMsg: "No error" });
                  }}
                >
                  Litigation Act
                </Nav.Link>

                <Nav.Link
                  className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite"
                  eventKey="todo"
                  onClick={() => {
                    setSelectedTab("todo");
                    setError({ error: false, errorMsg: "No error" });
                  }}
                >
                  TODO Event
                </Nav.Link>
                <Nav.Link
                  className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite apply-after"
                  eventKey="treatmentDay"
                  onClick={() => {
                    setSelectedTab("treatmentDay");
                    setError({ error: false, errorMsg: "No error" });
                  }}
                >
                  Treatment Date
                </Nav.Link>
              </Nav>
              <div className="">
                <Tab.Content>
                  <Tab.Pane eventKey={"search"}>
                    <Row style={{ paddingLeft: "5px", paddingRight: "5px" }} className="mx-0">
                      <Col md={12} className="p-0">
                        <div className="row mx-0 align-items-center custom-margin-bottom">
                          <div
                            className="col-md-12 ps-0 text-center  pe-0"
                            style={{
                              height: "42px",
                            }}
                          >
                            <span
                              className="text-center"
                              style={{
                                fontWeight: "600",
                                color: "var(--primary-25)",
                              }}
                            >
                              Kindly search through the dropdown menu and select the case that best
                              matches your requirements based on the detailed information provided
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <Row
                      style={{
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        height: "400px",
                        minHeight: "400px",
                      }}
                      className="mx-0"
                    >
                      <Col md={12} className="p-0">
                        <div className="row mx-0 align-items-start h-100 custom-margin-bottom">
                          <div className="col-md-3 ps-0 text-center  pe-0">
                            <DetailHeading
                              label="Client Name"
                              value={`${client?.first_name} ${client?.last_name}`}
                              icon={client?.profile_pic_19p || avatar}
                            />
                            <DetailHeading
                              label="Birthday"
                              value={client?.birthday ? formatCalendarDate(client.birthday) : ""}
                              icon={iconMapping["Birthday"]}
                            />
                            <DetailHeading
                              label="Case Type"
                              value={caseSummary?.case_type?.name}
                              icon={caseSummary?.case_type?.casetype_icon}
                            />

                            <DetailHeading
                              label="Incident Date"
                              value={formatCalendarDate(caseSummary?.incident_date)}
                              icon={iconMapping["Incident Date"]}
                            />
                          </div>

                          <div
                            className="col-md-9 h-100 p-l-5 text-center pe-0 d-flex flex-column"
                            style={{ borderLeft: "1px solid black", overflow: "hidden" }}
                          >
                            <div className="client-search flex-shrink-0" style={{ height: "25px" }}>
                              <input
                                type="text"
                                placeholder="Type 3 Characters to search for a client"
                                onFocus={(e) => {
                                  e.target.placeholder = "";
                                  e.target.style.color = "black";
                                }}
                                onBlur={(e) => {
                                  e.target.placeholder = "Type 3 Characters to search for a client";
                                }}
                                style={{ color: "var(--primary-25)", borderRadius: "0px" }}
                                className="form-control height-25"
                                value={searchClientByName.name}
                                onChange={(e) =>
                                  setSearchClientByName({
                                    ...searchClientByName,
                                    name: e.target.value,
                                  })
                                }
                              />
                            </div>

                            <div
                              style={{
                                flex: 1,
                                minHeight: 0,
                                overflowY: "auto",
                                overflowX: "hidden",
                                scrollbarWidth: "none",
                              }}
                            >
                              <EventClientTable
                                recs={searchResults}
                                isLoading={isLoadingApiSearch}
                                error={apiError}
                                searchTerm={debouncedSearchTerm}
                                setError={setError}
                                setSearch={setDebouncedSearchTerm}
                                setCaseProvider={setCaseProvider}
                                setClient={setClient}
                                setCaseSummary={setCaseSummary}
                                setCaseId={setCaseId}
                                setCurrentCase={setCurrentCase}
                                setAssignedUsers={setAssignedUsers}
                                setUniqueIdUsers={setUniqueIdUsers}
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey={"litigationAct"}>
                    <Row style={{ paddingLeft: "5px", paddingRight: "5px" }} className="mx-0">
                      <Col md={12} className="p-0">
                        <div className="row mx-0 align-items-center custom-margin-bottom">
                          <div className="col-md-12 ps-0 text-center  pe-0">
                            <span
                              className="text-center"
                              style={{
                                fontWeight: "600",
                                color: "var(--primary-25)",
                              }}
                            >
                              Enter the litigation act details in the input field below. Select the
                              date for the act. Then select the litigation type, litigation event
                              and click the green Add Litigation Act button.
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <Row
                      style={{
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        height: "400px",
                        minHeight: "400px",
                      }}
                      className="mx-0"
                    >
                      <Col md={12} className="p-0">
                        <div className="row mx-0 align-items-start custom-margin-bottom">
                          <div className="col-md-3 ps-0 text-center  pe-0">
                            <DetailHeading
                              label="Client Name"
                              value={`${client?.first_name} ${client?.last_name}`}
                              icon={client?.profile_pic_19p || avatar}
                            />
                            <DetailHeading
                              label="Birthday"
                              value={client?.birthday ? formatCalendarDate(client.birthday) : ""}
                              icon={iconMapping["Birthday"]}
                            />
                            <DetailHeading
                              label="Case Type"
                              value={caseSummary?.case_type?.name}
                              icon={caseSummary?.case_type?.casetype_icon}
                            />

                            <DetailHeading
                              label="Incident Date"
                              value={formatCalendarDate(caseSummary?.incident_date)}
                              icon={iconMapping["Incident Date"]}
                            />
                          </div>

                          <div
                            className="col-md-9 p-l-5 text-center  pe-0"
                            style={{
                              borderLeft: "1px solid black",
                            }}
                          >
                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div
                                style={{ minWidth: "130px" }}
                                className="col-md-2 ps-0 p-r-5 height-25 text-start"
                              >
                                <span
                                  style={{
                                    color: "var(--primary)",
                                    // background: "var(--primary-15)",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                  }}
                                  className="bg-primary-5 d-inline-block height-25 d-flex align-items-center text-nowrap"
                                >
                                  Litigation Type:
                                </span>
                              </div>
                              <div className="col-md-5 ps-0 pe-0 height-25">
                                <select
                                  placeholder="Select Litigation Type"
                                  defaultValue={eventData.litigation_event_type}
                                  className="height-25 col-md-12 pt-0 pb-0 form-control p-l-5 pe-0"
                                  onChange={(e) =>
                                    handleChange({
                                      target: {
                                        name: "litigation_event_type",
                                        value: e.target.value,
                                      },
                                    })
                                  }
                                >
                                  <option key="" value="">
                                    Select Litigation Type
                                  </option>
                                  {litigationEventType?.map((type) => (
                                    <option key={type?.id} value={type.id}>
                                      {type?.litigation_event_type}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div
                                style={{ minWidth: "130px" }}
                                className="col-md-2 ps-0 p-r-5 height-25 text-start"
                              >
                                <span
                                  style={{
                                    color: "var(--primary)",
                                    // background: "var(--primary-15)",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                  }}
                                  className="bg-primary-5 d-inline-block height-25 d-flex align-items-center text-nowrap"
                                >
                                  Litigation Events:
                                </span>
                              </div>
                              <div className="col-md-5 ps-0 pe-0 height-25">
                                <select
                                  placeholder="Select Litigation Events"
                                  defaultValue={eventData.litigation_event}
                                  className="height-25 col-md-12 pt-0 pb-0 form-control p-l-5 pe-0"
                                  onChange={(e) =>
                                    handleChange({
                                      target: {
                                        name: "litigation_event",
                                        value: e.target.value,
                                      },
                                    })
                                  }
                                >
                                  <option key="" value="">
                                    Select Litigation Event
                                  </option>
                                  {filterlitigationEvents?.map((type) => (
                                    <option key={type?.id} value={type.id}>
                                      {type?.event_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div
                                style={{ minWidth: "130px" }}
                                className="col-md-2 ps-0 p-r-5 height-25 text-start"
                              >
                                <span
                                  style={{
                                    color: "var(--primary)",
                                    // background: "var(--primary-15)",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                  }}
                                  className="bg-primary-5 d-inline-block height-25 d-flex align-items-center text-nowrap"
                                >
                                  Date:
                                </span>
                              </div>
                              <div className="col-md-5 ps-0 pe-0 height-25">
                                <input
                                  type="date"
                                  value={eventData.litigationDate ? eventData.litigationDate : ""}
                                  onChange={(e) =>
                                    handleDateChange(
                                      "litigationDate",
                                      e.target.value ? e.target.value : null
                                    )
                                  }
                                  className="form-control height-25 col-md-12 p-l-5 pe-0"
                                />
                              </div>
                            </div>

                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div
                                // style={{ minWidth: "130px" }}
                                className="col-md-3 ps-0 p-r-5 height-25 text-start"
                              >
                                <span
                                  style={{
                                    color: "var(--primary)",
                                    // background: "var(--primary-15)",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                  }}
                                  className="bg-primary-5 d-inline-block height-25 d-flex align-items-center text-nowrap"
                                >
                                  Litigation Act Details:
                                </span>
                              </div>
                              <div className="col-md-9 ps-0 pe-0 height-25">
                                <textarea
                                  name="litigationActDescription"
                                  value={eventData.litigationActDescription}
                                  onChange={handleChange}
                                  className="form-control  col-md-12 p-l-5 pe-0"
                                  placeholder="Enter Litigation Act Details....."
                                  style={{ resize: "none", height: "50px" }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey={"todo"}>
                    <Row style={{ paddingLeft: "5px", paddingRight: "5px" }} className="mx-0">
                      <Col md={12} className="p-0">
                        <div className="row mx-0 align-items-center custom-margin-bottom">
                          <div className="col-md-12 ps-0 text-center  pe-0">
                            <span
                              className="text-center"
                              style={{
                                fontWeight: "600",
                                color: "var(--primary-25)",
                              }}
                            >
                              Type the todo description in the input field below. Select the due
                              date for the todo. Then select the category type and case workers, and
                              click the green Add TODO Event button.
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <Row
                      style={{
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        height: "400px",
                        minHeight: "400px",
                        overflow: "hidden",
                      }}
                      className="mx-0"
                    >
                      <Col md={12} className="p-0">
                        <div className="row mx-0 align-items-start custom-margin-bottom">
                          <div className="col-md-3 ps-0 text-center  pe-0">
                            <DetailHeading
                              label="Client Name"
                              value={`${client?.first_name} ${client?.last_name}`}
                              icon={client?.profile_pic_19p || avatar}
                            />
                            <DetailHeading
                              label="Birthday"
                              value={client?.birthday ? formatCalendarDate(client.birthday) : ""}
                              icon={iconMapping["Birthday"]}
                            />
                            <DetailHeading
                              label="Case Type"
                              value={caseSummary?.case_type?.name}
                              icon={caseSummary?.case_type?.casetype_icon}
                            />

                            <DetailHeading
                              label="Incident Date"
                              value={formatCalendarDate(caseSummary?.incident_date)}
                              icon={iconMapping["Incident Date"]}
                            />
                          </div>

                          <div
                            className="col-md-9 p-l-5 text-center  pe-0"
                            style={{
                              borderLeft: "1px solid black",
                            }}
                          >
                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div
                                style={{ minWidth: "130px" }}
                                className="col-md-2 ps-0 p-r-5 height-25 text-start"
                              >
                                <span
                                  style={{
                                    color: "var(--primary)",
                                    // background: "var(--primary-15)",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                  }}
                                  className="bg-primary-5 d-inline-block height-25 d-flex align-items-center text-nowrap"
                                >
                                  Category Type
                                </span>
                              </div>
                              <div className="col-md-5 ps-0 pe-0 height-25">
                                <select
                                  placeholder="Select Category"
                                  defaultValue={eventData.category_type}
                                  className="height-25 col-md-12 pt-0 pb-0 form-control p-l-5 pe-0"
                                  onChange={(e) =>
                                    handleChange({
                                      target: {
                                        name: "category_type",
                                        value: e.target.value,
                                      },
                                    })
                                  }
                                >
                                  <option key="" value="">
                                    Select Category
                                  </option>
                                  {todoCategoryType?.map((type) => (
                                    <option key={type?.id} value={type.id}>
                                      {type?.tab_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div
                                style={{ minWidth: "130px" }}
                                className="col-md-2 ps-0 p-r-5 height-25 text-start"
                              >
                                <span
                                  style={{
                                    color: "var(--primary)",
                                    // background: "var(--primary-15)",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                  }}
                                  className="bg-primary-5 d-inline-block height-25 d-flex align-items-center text-nowrap"
                                >
                                  Due Date:
                                </span>
                              </div>
                              <div className="col-md-5 ps-0 pe-0 height-25">
                                <input
                                  type="date"
                                  value={eventData.todoDate ? eventData.todoDate : ""}
                                  onChange={(e) =>
                                    handleDateChange(
                                      "todoDate",
                                      e.target.value ? e.target.value : null
                                    )
                                  }
                                  className="form-control height-25 col-md-12 p-l-5 pe-0"
                                />
                              </div>
                            </div>

                            <div
                              style={{
                                height: "50px",
                              }}
                              className="row mx-0 align-items-start custom-margin-bottom"
                            >
                              <div
                                // style={{ minWidth: "130px" }}
                                className="col-md-3 ps-0 p-r-5 height-25 text-start"
                              >
                                <span
                                  style={{
                                    color: "var(--primary)",
                                    // background: "var(--primary-15)",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                  }}
                                  className="bg-primary-5 d-inline-block height-25 d-flex align-items-center text-nowrap"
                                >
                                  Todo Description:
                                </span>
                              </div>
                              <div className="col-md-9 ps-0 pe-0 height-25">
                                <textarea
                                  name="todoDescription"
                                  value={eventData.todoDescription}
                                  onChange={handleChange}
                                  className="form-control  col-md-12 p-l-5 pe-0"
                                  placeholder="Enter a Case Note, New To-Do..."
                                  style={{ resize: "none", height: "50px" }}
                                />
                              </div>
                            </div>

                            <>
                              <div
                                className="align-items-center m-t-5 m-b-5"
                                style={{ width: "100%" }}
                              >
                                <ClientSelection
                                  case_users={case_users}
                                  case_users1={case_users1}
                                  caseWorkers={caseWorkers}
                                  uniqueIdUsers={uniqueIdUsers}
                                  assignedUsers={assignedUsers}
                                  setAssignedUsers={setAssignedUsers}
                                  setUniqueIdUsers={setUniqueIdUsers}
                                  setBlurModal={setBlurModal}
                                />
                              </div>

                              <div className="align-items-center m-b-5" style={{ width: "100%" }}>
                                <OtherFirmUsers
                                  notesFirmUsers={firmUsers}
                                  uniqueIdFirmUsers={uniqueIdFirmUsers}
                                  assignedFirmUsers={assignedFirmUsers}
                                  setAssignedFirmUsers={setAssignedFirmUsers}
                                  setUniqueIdFirmUsers={setUniqueIdFirmUsers}
                                  setBlurModal={setBlurModal}
                                />
                              </div>
                            </>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey={"treatmentDay"}>
                    <Row
                      style={{
                        paddingLeft: "5px",
                        paddingRight: "5px",
                      }}
                      className="mx-0"
                    >
                      <Col md={12} className="p-0">
                        <div className="row mx-0 align-items-center custom-margin-bottom">
                          <div
                            className="col-md-12 ps-0 text-center  pe-0"
                            style={{
                              height: "42px",
                            }}
                          >
                            <span
                              className="text-center"
                              style={{
                                fontWeight: "600",
                                color: "var(--primary-25)",
                              }}
                            >
                              Provide details of the treatment day in the text area below. Select
                              the treatment date and case provider, and click the green Add
                              Treatment Day button.
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <Row
                      style={{
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        height: "400px",
                        minHeight: "400px",
                        overflow: "hidden",
                      }}
                      className="mx-0"
                    >
                      <Col md={12} className="p-0">
                        <div className="row mx-0 align-items-start custom-margin-bottom">
                          <div className="col-md-3 ps-0 text-center  pe-0">
                            <DetailHeading
                              label="Client Name"
                              value={`${client?.first_name} ${client?.last_name}`}
                              icon={client?.profile_pic_19p || avatar}
                            />
                            <DetailHeading
                              label="Birthday"
                              value={client?.birthday ? formatCalendarDate(client.birthday) : ""}
                              icon={iconMapping["Birthday"]}
                            />
                            <DetailHeading
                              label="Case Type"
                              value={caseSummary?.case_type?.name}
                              icon={caseSummary?.case_type?.casetype_icon}
                            />

                            <DetailHeading
                              label="Incident Date"
                              value={formatCalendarDate(caseSummary?.incident_date)}
                              icon={iconMapping["Incident Date"]}
                            />
                          </div>

                          <div
                            className="col-md-9 p-l-5 text-center  pe-0"
                            style={{
                              borderLeft: "1px solid black",
                            }}
                          >
                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div
                                style={{ minWidth: "130px" }}
                                className="col-md-2 ps-0 p-r-5 height-25 text-start"
                              >
                                <span
                                  style={{
                                    color: "var(--primary)",
                                    // background: "var(--primary-15)",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                  }}
                                  className="bg-primary-5 d-inline-block height-25 d-flex align-items-center text-nowrap"
                                >
                                  Case Provider
                                </span>
                              </div>
                              <div className="col-md-5 ps-0 pe-0 height-25">
                                <select
                                  placeholder="Select Case Provider"
                                  defaultValue={eventData.for_provider}
                                  className="height-25 col-md-12 pt-0 pb-0 form-control p-l-5 pe-0"
                                  onChange={(e) =>
                                    handleChange({
                                      target: {
                                        name: "for_provider",
                                        value: e.target.value,
                                      },
                                    })
                                  }
                                >
                                  <option key="" value="">
                                    Select Case Provider
                                  </option>
                                  {caseProvider?.map((provider) => (
                                    <option key={provider?.id} value={provider?.id}>
                                      {provider?.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="row mx-0 align-items-center custom-margin-bottom">
                              <div
                                style={{ minWidth: "130px" }}
                                className="col-md-2 ps-0 p-r-5 height-25 text-start"
                              >
                                <span
                                  style={{
                                    color: "var(--primary)",
                                    // background: "var(--primary-15)",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                  }}
                                  className="bg-primary-5 d-inline-block height-25 d-flex align-items-center text-nowrap"
                                >
                                  Treatment Date:
                                </span>
                              </div>
                              <div className="col-md-5 ps-0 pe-0 height-25">
                                <input
                                  type="date"
                                  value={eventData.treatmentDate ? eventData.treatmentDate : ""}
                                  onChange={(e) =>
                                    handleDateChange(
                                      "treatmentDate",
                                      e.target.value ? e.target.value : null
                                    )
                                  }
                                  className="form-control height-25 col-md-12 p-l-5 pe-0"
                                />
                              </div>
                            </div>

                            <div
                              style={{
                                height: "50px",
                              }}
                              className="row mx-0 align-items-start custom-margin-bottom"
                            >
                              <div
                                // style={{ minWidth: "130px" }}
                                className="col-md-3 ps-0 p-r-5 height-25 text-start"
                              >
                                <span
                                  style={{
                                    color: "var(--primary)",
                                    // background: "var(--primary-15)",
                                    fontWeight: "600",
                                    paddingLeft: "5px",
                                  }}
                                  className="bg-primary-5 d-inline-block height-25 d-flex align-items-center text-nowrap"
                                >
                                  Treatment Description:
                                </span>
                              </div>
                              <div className="col-md-9 ps-0 pe-0 height-25">
                                <textarea
                                  name="treatmentDayDescription"
                                  value={eventData.treatmentDayDescription}
                                  onChange={handleChange}
                                  className="form-control  col-md-12 p-l-5 pe-0"
                                  placeholder="Enter Treatment Day details..."
                                  style={{ resize: "none", height: "50px" }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </Tab.Container>
          </div>
        </Modal.Body>

        <Modal.Footer
          className="p-0 mt-0 padding-outside-btn-new-provider"
          style={{ borderTop: "none" }}
        >
          <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
            variant="secondary"
            onClick={() => setShow(false)}
          >
            Cancel
          </Button>

          <Button
            className={`btn button-padding-footer-new-provider d-flex align-items-center justify-content-center btn-success ${!successBtnFlag ? "disabled" : ""}`}
            variant={!successBtnFlag ? "secondary" : "success"}
            style={{
              visibility: selectedTab === "search" ? "hidden" : "visible",
              minWidth: "108px",
            }}
            onClick={handleSubmit}
            disabled={!successBtnFlag}
          >
            {selectedTab === "litigationAct"
              ? "Add Litigation Act"
              : selectedTab === "todo"
                ? "Add TODO Event"
                : selectedTab === "treatmentDay"
                  ? "Add Treatment Day"
                  : "Select Case"}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default EventModal;
